module.exports = __webpack_public_path__ + "img/malla borreguera.12ce7e88.jpg";